<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <b-form @submit="onSubmit" @button="onDelete" v-if="show">
          <b-form-group id="uidGroup" label="uid:" label-for="uid">
            <b-form-input
              id="uid"
              type="text"
              v-model="form.uid"
              placeholder="uid"
            />
          </b-form-group>
          <b-form-group id="emailGroup" label="E-postadress:" label-for="email">
            <b-form-input
              id="email"
              type="email"
              v-model="form.email"
              required
              placeholder="E-postadress"
            />
          </b-form-group>
          <b-form-group id="userNameGroup" label="Användarnamn:" label-for="userName">
            <b-form-input
              id="userName"
              type="text"
              v-model="form.userName"
              required
              placeholder="Användarnamn"
            />
          </b-form-group>
          <b-form-group id="firstNameGroup" label="Förnamn:" label-for="firstName">
            <b-form-input
              id="firstName"
              type="text"
              v-model="form.firstName"
              required
              placeholder="Förnamn"
            />
          </b-form-group>
          <b-form-group id="lastNameGroup" label="Efternamn:" label-for="lastName">
            <b-form-input
              id="lastName"
              type="text"
              v-model="form.lastName"
              required
              placeholder="Efternamn"
            />
          </b-form-group>
          <b-form-group id="phoneGroup" label="Telefon:" label-for="phone">
            <b-form-input
              id="phone"
              type="text"
              v-model="form.phone"
              required
              placeholder=""
            />
          </b-form-group>
          <b-form-group id="roleGroup" label="Roll:" label-for="roles">
            <b-form-select id="roles" :options="roles" required v-model="form.role" />
          </b-form-group>
          <b-form-group id="trucksGroup" label="Standard lastbil:" label-for="trucks">
            <b-form-select id="trucks" :options="trucks" v-model="form.truckId" />
          </b-form-group>
          <b-form-group id="trailersGroup" label="Standard släp:" label-for="trailers">
            <b-form-select id="trailers" :options="trailers" v-model="form.trailerId" />
          </b-form-group>
          <b-form-checkbox id="checkbox-C" v-model="form.permissionC" name="permissionC" value="Ja" unchecked-value="Nej">Behörighet C</b-form-checkbox>
          <b-form-checkbox id="checkbox-CE" v-model="form.permissionCE" name="permissionCE" value="Ja" unchecked-value="Nej">Behörighet CE</b-form-checkbox>
          <b-form-checkbox id="checkbox-ADR" v-model="form.permissionADR" name="permissionADR" value="Ja" unchecked-value="Nej">Behörighet ADR</b-form-checkbox>
          <b-form-checkbox id="checkbox-ADRTank" v-model="form.permissionADRTank" name="permissionADRTank" value="Ja" unchecked-value="Nej">Behörighet ADR Tank</b-form-checkbox>
          <b-form-checkbox id="checkbox-Truck" v-model="form.permissionTruck" name="permissionTruck" value="Ja" unchecked-value="Nej">Truckförarbevis</b-form-checkbox>
          <b-form-checkbox id="checkbox-Bakgavel" v-model="form.permissionBakgavel" name="permissionBakgavel" value="Ja" unchecked-value="Nej">Bakgavelliftbevis</b-form-checkbox>
          <b-form-checkbox id="checkbox-Kran" v-model="form.permissionKran" name="permissionKran" value="Ja" unchecked-value="Nej">Kranförarbevis</b-form-checkbox>
          <b-form-checkbox id="permissionLoadAcidFromKemira" v-model="form.permissionLoadAcidFromKemira" name="permissionLoadAcidFromKemira" value="Ja" unchecked-value="Nej">Behörighet lasta från Kemira</b-form-checkbox>
          <b-form-checkbox id="permissionLoadAcidFromInovyn" v-model="form.permissionLoadAcidFromInovyn" name="permissionLoadAcidFromInovyn" value="Ja" unchecked-value="Nej">Behörighet lasta från Inovyn</b-form-checkbox>
          <b-form-checkbox id="permissionLoadProductFromVet" v-model="form.permissionLoadProductFromVet" name="permissionLoadProductFromVet" value="Ja" unchecked-value="Nej">Behörighet lasta från Vetlanda</b-form-checkbox>
          <b-form-checkbox id="permissionLoadProductFromSol" v-model="form.permissionLoadProdFrSolE90" name="permissionLoadProdFrSolE90" value="Ja" unchecked-value="Nej">Behörighet lasta från Sölvesborg Eko 90 </b-form-checkbox>
          <b-form-checkbox id="permissionLoadProdFrSolE70" v-model="form.permissionLoadProdFrSolE70" name="permissionLoadProdFrSolE70" value="Ja" unchecked-value="Nej">Behörighet lasta från Sölvesborg Eko 70 </b-form-checkbox>
          <b-form-checkbox id="permissionLoadProdFrSolFE" v-model="form.permissionLoadProdFrSolFE" name="permissionLoadProdFrSolFE" value="Ja" unchecked-value="Nej">Behörighet lasta från Sölvesborg Järnklorid </b-form-checkbox>
          <b-form-checkbox id="permissionLoadProdFrSolPlusP" v-model="form.permissionLoadProdFrSolPlusP" name="permissionLoadProdFrSolPlusP" value="Ja" unchecked-value="Nej">Behörighet lasta från Sölvesborg Pluspac </b-form-checkbox>
          <b-form-checkbox id="permissionLoadProdFrSolLut" v-model="form.permissionLoadProdFrSolLut" name="permissionLoadProdFrSolLut" value="Ja" unchecked-value="Nej">Behörighet lasta från Sölvesborg Lut </b-form-checkbox>
          <b-form-checkbox id="permissionUnloadProductInVet" v-model="form.permissionUnloadProductInVet" name="permissionUnloadProductInVet" value="Ja" unchecked-value="Nej">Behörighet lossa i Vetlanda</b-form-checkbox>
          <b-form-checkbox id="permissionUnloadProductInSol" v-model="form.permissionUnloadProductInSol" name="permissionUnloadProductInSol" value="Ja" unchecked-value="Nej">Behörighet lossa i Sölvesborg</b-form-checkbox>
          <b-form-checkbox id="checkbox-subContractor" v-model="form.subContractor" name="subContractor" value="Ja" unchecked-value="Nej">Underleverantör</b-form-checkbox>
          <b-form-checkbox id="checkbox-inActive" v-model="form.inActive" name="inActive" value="Ja" unchecked-value="Nej">Inaktiv (<i style="font-size: 12px">Användaren finns kvar i systemet men kan inte logga in och syns inte i några listor.</i>)</b-form-checkbox>
          <b-form-group id="customersGroup" label="Kund:" label-for="customers">
            <b-form-select id="customers" :options="customers" v-model="form.customerId" />
          </b-form-group>
           <b-form-group id="passwordGroup" label="Nytt lösenord:" label-for="password"  v-if="showPassword">
            <b-form-input
              id="password"
              type="password"
              v-model="form.password"
              placeholder="Nytt lösenord"
              name="password"
              required
            />
          </b-form-group>
           <b-form-group id="passwordGroup2" label="Bekräfta lösenord:" label-for="password2"  v-if="showPassword">
            <b-form-input
              id="password2"
              type="password"
              placeholder="Skriv lösenordet igen"
              name="password2"
              required
            />
          </b-form-group>
          <b-form-group id="vehicles" label="Begränsa fordon:">
            <p>Välj vilka fordon du vill att chauffören endast ska se i appen.</p>
            <MultiSelect style="min-width: 15rem;" v-model="form.data.selectedVehicles" :options="vehicles" optionLabel="name" display="chip" placeholder="Välj fordon..." />
          </b-form-group>
          <b-form-group>
            <label>App-version: {{form.data.appVersion}}</label>
          </b-form-group>
          <Button v-if="user.role == 'Driver'" @click="onSyncToTS" label="Synka med TS" class="p-button-success" icon="pi pi-check" ></Button>
          <Button v-if="showPassword == false" :label="showPasswordText" class="p-button-success" @click="showPasswordToggle()" icon="pi pi-check" ></Button>
          <Button :type="submit" label="Spara" class="p-button-success" icon="pi pi-check" ></Button>
          <Button  label="Ta bort" class="p-button-danger" @click="onDelete" icon="pi pi-times" ></Button>
        </b-form>
      </div>
    </div>
    <Toast position="topright" />
  </div>
</template>

<script>
import Button from 'primevue/button'
import Toast from 'primevue/toast'
import MultiSelect from 'primevue/multiselect'
export default {
  name: 'UserDetails',
  components: {
    Button,
    MultiSelect,
    Toast
  },
  data () {
    return {
      msg: 'Användare',
      user: '',
      show: true,
      showPassword: false,
      showPasswordText: 'Ändra lösenord',
      vehicles: [],
      form: {
        uid: '',
        email: '',
        userName: '',
        firstName: '',
        lastName: '',
        phone: '',
        role: null,
        password: '',
        customerId: null,
        permissionC: '',
        permissionCE: '',
        permissionADR: '',
        permissionADRTank: '',
        permissionTruck: '',
        permissionBakgavel: '',
        permissionKran: '',
        permissionLoadAcidFromKemira: '',
        permissionLoadAcidFromInovyn: '',
        permissionLoadProductFromVet: '',
        permissionLoadProdFrSolE90: 'Nej',
        permissionLoadProdFrSolE70: 'Nej',
        permissionLoadProdFrSolFE: 'Nej',
        permissionLoadProdFrSolPlusP: 'Nej',
        permissionLoadProdFrSolLut: 'Nej',
        permissionUnloadProductInVet: '',
        permissionUnloadProductInSol: '',
        subContractor: '',
        inActive: '',
        truckId: null,
        trailerId: null,
        data: {
          selectedVehicles: [],
          appVersion: ''
        }
      },
      roles: [{ text: 'Välj..', value: null }, 'User', 'Driver', 'Admin', 'Extern', 'Revisor'],
      customers: [{ text: 'Välj..', value: null }],
      trucks: [{ text: 'Välj..', value: null }],
      trailers: [{ text: 'Välj..', value: null }]
    }
  },
  methods: {
    getCustomers () {
      this.$http
        .get('/api/customers')
        .then(response => {
          var customers = response.data.customers
          for (var i = 0; i < customers.length; i++) {
            this.customers.push({value: customers[i].id, text: customers[i].data.name})
          }
        })
        .catch(error => console.log(error))
    },
    getTrucks () {
      this.$http
        .get('/api/objectdatas/objectgroupid/2')
        .then(response => {
          var trucks = response.data
          for (var i = 0; i < trucks.length; i++) {
            if (!trucks[i].data.inActive) {
              this.trucks.push({'value': trucks[i].id, 'text': trucks[i].data.regnbr})
              this.vehicles.push({'value': trucks[i].id, 'name': trucks[i].data.regnbr})
            }
          }
        })
        .catch(error => console.log(error))
    },
    getTrailers () {
      this.$http
        .get('/api/objectdatas/objectgroupid/3')
        .then(response => {
          var trucks = response.data
          for (var i = 0; i < trucks.length; i++) {
            if (!trucks[i].data.inActive) {
              this.trailers.push({'value': trucks[i].id, 'text': trucks[i].data.regnbr})
              this.vehicles.push({'value': trucks[i].id, 'name': trucks[i].data.regnbr})
            }
          }
        })
        .catch(error => console.log(error))
    },
    showPasswordToggle () {
      if (this.showPassword === false) {
        this.showPassword = true
      } else {
        this.showPassword = false
        this.showPasswordText = 'Ändra lösenord'
      }
    },
    onSubmit (evt) {
      evt.preventDefault()
      var url = '/api/users/' + this.$route.params.id
      this.$http
        .put(url, { user: this.form })
        .then(response => {
          this.$router.push('/userlist')
        })
        .catch(error => console.log(error))
    },
    onSyncToTS (evt) {
      evt.preventDefault()
      var url = '/api/users/synctots/' + this.$route.params.id
      this.$http
        .put(url, { user: this.form })
        .then(response => {
          this.form.uid = response.data.uid
          this.$toast.add({severity: 'success', summary: 'Chaufför sparad i TS', life: 3000})
        })
        .catch(error => console.log(error))
    },
    onDelete (evt) {
      evt.preventDefault()
      let message = 'Är du säker?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          var url = '/api/users/' + this.$route.params.id
          this.$http
            .delete(url)
            .then(response => {
              this.$router.push('/userlist')
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    }
  },
  created () {
    this.getCustomers()
    this.getTrucks()
    this.getTrailers()
    var url = '/api/users/' + this.$route.params.id
    this.$http
      .get(url)
      .then(response => {
        this.user = response.data
        this.form.uid = this.user.uid
        this.form.email = this.user.email
        this.form.userName = this.user.userName
        this.form.firstName = this.user.firstName
        this.form.lastName = this.user.lastName
        this.form.phone = this.user.phone
        this.form.role = this.user.role
        this.form.customerId = this.user.customerId
        this.form.permissionC = this.user.permissionC
        this.form.permissionCE = this.user.permissionCE
        this.form.permissionADR = this.user.permissionADR
        this.form.permissionADRTank = this.user.permissionADRTank
        this.form.permissionTruck = this.user.permissionTruck
        this.form.permissionBakgavel = this.user.permissionBakgavel
        this.form.permissionKran = this.user.permissionKran

        this.form.permissionLoadAcidFromKemira = this.user.permissionLoadAcidFromKemira
        this.form.permissionLoadAcidFromInovyn = this.user.permissionLoadAcidFromInovyn
        this.form.permissionLoadProductFromVet = this.user.permissionLoadProductFromVet
        this.form.permissionLoadProdFrSolE90 = this.user.permissionLoadProdFrSolE90
        this.form.permissionLoadProdFrSolE70 = this.user.permissionLoadProdFrSolE70
        this.form.permissionLoadProdFrSolFE = this.user.permissionLoadProdFrSolFE
        this.form.permissionLoadProdFrSolPlusP = this.user.permissionLoadProdFrSolPlusP
        this.form.permissionLoadProdFrSolLut = this.user.permissionLoadProdFrSolLut
        this.form.permissionUnloadProductInVet = this.user.permissionUnloadProductInVet
        this.form.permissionUnloadProductInSol = this.user.permissionUnloadProductInSol

        this.form.inActive = this.user.inActive
        this.form.truckId = this.user.truckId
        this.form.trailerId = this.user.trailerId
        this.form.subContractor = this.user.subContractor
        if (this.user.data !== null && this.user.data.selectedVehicles !== null) {
          this.form.data.selectedVehicles = this.user.data.selectedVehicles
        }
        if (this.user.appVersion !== null && this.user.data.appVersion !== null) {
          this.form.data.appVersion = this.user.data.appVersion
        }
      })
      .catch(error => console.log(error))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Users/UserDetails.vue